import { render, staticRenderFns } from "./entry-test-result.vue?vue&type=template&id=626d4540&scoped=true"
import script from "./entry-test-result.vue?vue&type=script&lang=js"
export * from "./entry-test-result.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "626d4540",
  null
  
)

export default component.exports